export default {
  name: "InfoCarousel",
  props: ["items"],
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("resize", this.changeGalleryWidth);
      document.addEventListener("DOMContentLoaded", this.changeGalleryWidth);
    });
  },
  methods: {
    changeMainPhoto: function (index) {
      this.$refs.carousel.setActiveItem(index);
    },

    changeGalleryWidth: function () {
      let gallery = document.querySelector(".thumb-photos-wrap");
      if (!gallery) {
        return false;
      }
      let imgNumber = gallery.childElementCount;
      let galleryWidth = gallery.clientWidth;

      let img = document.querySelector(".thumb-photo");
      let style = img.currentStyle || window.getComputedStyle(img);
      let marginLeft = style.marginLeft;
      let marginRight = style.marginRight;
      let width = style.width;
      let imgWidth =
        parseInt(marginLeft) + parseInt(marginRight) + parseInt(width);

      if (galleryWidth / Math.ceil(imgNumber / 2) < imgWidth) {
        let newWidth = Math.ceil(imgNumber / 2) * imgWidth;
        const minWidth = 400;
        gallery.style.width =
          newWidth > minWidth
            ? Math.ceil(imgNumber / 2) * imgWidth + "px"
            : minWidth + "px";
      } else {
        gallery.style.width = gallery.parentElement.clientWidth + "px";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.changeGalleryWidth);
    document.removeEventListener("DOMContentLoaded", this.changeGalleryWidth);
  }
};
